import { useCookieConsent, Locale } from '@scouts/helpers'
import { CookieConsentOverlay } from '@scouts/ui'

import cookieImage from '@/assets/images/icon-cookie.png'

export const CookieConsent = () => {
    const { isVisible, acceptCookies, rejectCookies, openPreferences } = useCookieConsent()

    if (isVisible)
        return (
            <CookieConsentOverlay
                locale={Locale.ES}
                imageSrc={cookieImage}
                onAccept={acceptCookies}
                onReject={rejectCookies}
                onOpenPreferences={openPreferences}
            />
        )

    return null
}
